import styled from 'styled-components'

export const Buttons = styled.div`
  button {
    width: 100%;
    padding: 1.2rem 2rem;
    text-align: left;
  }
`
